import { Component, OnInit } from '@angular/core';
import { Observable } from 'src/app/classes/observable';
import { MfaService } from 'src/app/service/mfa.service';

@Component({
  selector: 'app-mfavalidate',
  templateUrl: './mfavalidate.component.html',
  styleUrls: ['./mfavalidate.component.scss'],
})
export class MfavalidateComponent implements OnInit {

  public code;
  public codigoInvalido = false;
  public invalido = false;
  public static EVENT = "modalMFAValidateDismiss";
  public static EVENT_CLOSE = "modalMFAValidateClose";
  
  public static EVENT_RESULT = "resultMFA";
  public static EVENT_RESULT_CLOSE = "CloseMFA";
  constructor(public MfaService:MfaService) { }

  ngOnInit() {}
  
  onChange(code) {
    this.code = code;
    this.invalido = false;
    this.codigoInvalido = false;
  }

  validarCodigo() {
    this.invalido=false;
    this.MfaService.validarMFA(this.code).then(data =>{
        Observable.notify(MfavalidateComponent.EVENT,true);
    }).catch(err => {
      this.codigoInvalido = true;
      this.invalido=true;
    });

    
  }

  salir() {
    Observable.notify(MfavalidateComponent.EVENT_CLOSE,true);
    //location.reload();
  }

}

